// 文章弹窗

import styles from './index.less';
import $ from 'jquery';
import Modal from '../modal';
import { creatQrcodeImg, isPc } from '../../utils/utils';
import { iconfont } from '../../utils/utils';
const defaultPrams = {
  configShare: null,
};
export default class QrcodeModal extends Modal {
  constructor(props) {
    super(props);
    this.params = {
      ...defaultPrams,
      ...props,
    };
    this._initContent();
    this._initCode();
  }
  _initContent() {
    this.$article = $(
      `<div class="${styles['article-wrapper']}">
        <div class="${styles['article-title']}">
          <span>扫一扫分享</span>
          <span class="${styles['close-btn']}">
            ${iconfont('iconUC-quxiao',styles.iconfont)}
          </span>
        </div>
        <article class="${styles['article-content']}">
          <div id="${styles['qrcode-wrapper']}">
            <img />
          </div>
          ${!isPc() ? `<p class="${styles['qrcode-tip']}">长按识别或保存二维码进行分享</p>` : ''}
        </article>
      </div>`,
    );
    // this.$closeBtn.on('click', () => {
    //   this.hide();
    // });
    this.$dom.append(this.$article);
    $(`.${styles['article-wrapper']} .${styles['close-btn']}`).on('click', () => {
      this.hide();
    });
  }
  _initCode() {
    const configShare = this.params.configShare;
    if (!configShare) return;
    creatQrcodeImg({
      logo: configShare.logo,
      url: configShare.url,
      success: base64ImgSrc => {
        if (base64ImgSrc) {
          $(`#${styles['qrcode-wrapper']} img`).attr('src', base64ImgSrc);
        }
      },
    });
  }
}
